module.exports = __webpack_public_path__ + "img/img9.cb16a74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/04/img9.png
// module id = 240
// module chunks = 0